import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconClock = ({
  title = "Clock",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#F77769" cx="32" cy="32" r="32" />
      <path
        d="M32 15a17 17 0 110 34 17 17 0 010-34zm0 2a15 15 0 100 30 15 15 0 000-30zm1 7.5v6.7l3.4 3.4c.8.8.8 1 0 1.8s-1 .8-1.8 0L31 32.8v-8.3c0-1.1-.1-2 1-2s1 .9 1 2z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </Svg.Icon>
)

export default IconClock
